import { useInstantSearch } from 'react-instantsearch';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import { useLayoutEffect } from 'react';

export const InsightsMiddleware = () => {
  const { addMiddlewares } = useInstantSearch();

  useLayoutEffect(() => {
    const middleware = createInsightsMiddleware({
      onEvent: () => {}, // prevent algolia defualt events firing
    });

    return addMiddlewares(middleware);
  }, [addMiddlewares]);

  return null;
};
